import { createAction } from 'redux-actions';


/*
 * Jwt
 */
export const userDidLogin = createAction('USER_DID_LOGIN');
export const userWillLogout = createAction('USER_WILL_LOGOUT');



// WEBPACK FOOTER //
// ./src/shared/actions/session.js